import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { GenericInput } from '../../common';
import ModalInvoice from '../../common/ModalInvoice';
import ModalAccountId from '../../common/ModalAccountId';

const searchInputs = [
  {
    label: 'label.startDate',
    name: 'startDate',
    type: 'date',
  },
  {
    label: 'label.endDate',
    name: 'endDate',
    type: 'date',
  },
  {
    label: 'label.jobType',
    name: 'type',
    tOptions: 'selections:jobTypes',
    isClearable: true,
    type: 'select',
  },
  {
    label: 'label.status',
    name: 'status',
    tOptions: 'selections:jobStatus',
    isClearable: true,
    type: 'select',
  },
  {
    label: 'label.accountId',
    name: 'accountId',
    fa: 'fa fa-external-link',
  },
  {
    label: 'label.invoiceId',
    name: 'invoiceId',
    fa: 'fa fa-external-link',
  },
];

class JobDetailSearchForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalName: '',
    };
  }

  componentDidMount() {
    this.setDefaultInputs();
  }

  setDefaultInputs = () => {
    searchInputs.map(input => this.setState({ [input.name]: null }));
  };

  handleInputChange = ({ name, value }) => {
    this.setState({ [name]: value });
  };

  handleSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    const { onSubmit } = this.props;
    const data = {};
    searchInputs.map(input => (this.state[input.name] ? (data[input.name] = this.state[input.name]) : null));
    if (onSubmit) {
      onSubmit(data);
    }
  };

  handleReset = e => {
    e.preventDefault();
    e.stopPropagation();
    // const { onSubmit } = this.props;
    this.setDefaultInputs();
    // if (onSubmit) {
    //   onSubmit({});
    // }
  };

  onSelect = (value, row) => {
    const { modalName } = this.state;
    this.setState({ [modalName]: value, modalName: '' });
  };

  onOpenModal = ({ modalName }) => {
    this.setState({ modalName });
  };

  onToggleModal = () => {
    this.setState({ modalName: '' });
  };

  render() {
    const { isSubmitting, t } = this.props;
    const { modalName } = this.state;
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-row">
          {searchInputs.map(item => (
            <GenericInput
              key={item.name}
              {...item}
              label={t && t(item.label) ? t(item.label) : item.label}
              value={this.state[item.name]}
              onChange={this.handleInputChange}
              onClick={item.fa ? () => this.onOpenModal({ modalName: item.name }) : () => {}}
            />
          ))}
          <div className="form-group text-right btn-search-actions col-md-6">
            <label htmlFor="validationCustom01se" />
            <br />
            <button
              type="button"
              className="button button-border black x-small"
              disabled={isSubmitting}
              onClick={this.handleReset}
            >
              {t('label.clear')}
            </button>
            <button type="submit" className="button x-small" disabled={isSubmitting}>
              {t('label.search')}
            </button>
          </div>
        </div>
        <ModalInvoice
          isOpen={modalName === 'invoiceId'}
          onSelect={this.onSelect}
          onCancel={this.onToggleModal}
          selectedParentId={this.state && this.state.invoiceId ? this.state.invoiceId : ''}
          accountId={this.state.accountId ? this.state.accountId : ''}
        />
        <ModalAccountId
          isOpen={modalName === 'accountId'}
          onSelect={this.onSelect}
          onCancel={this.onToggleModal}
          selectedParentId={this.state && this.state.accountId ? this.state.accountId : ''}
        />
      </form>
    );
  }
}

JobDetailSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

JobDetailSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(JobDetailSearchForm);
